namespace GeniuzPOS.PosShift {
    export namespace PsPriceOverrideTranService {
        export const baseUrl = 'PosShift/PsPriceOverrideTran';

        export declare function Create(request: Serenity.SaveRequest<PsPriceOverrideTranRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsPriceOverrideTranRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsPriceOverrideTranRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsPriceOverrideTranRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "PosShift/PsPriceOverrideTran/Create",
            Update = "PosShift/PsPriceOverrideTran/Update",
            Delete = "PosShift/PsPriceOverrideTran/Delete",
            Retrieve = "PosShift/PsPriceOverrideTran/Retrieve",
            List = "PosShift/PsPriceOverrideTran/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsPriceOverrideTranService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
